import { keyframes } from '@emotion/react'

export const rippleAnimation = keyframes`
  from {
    opacity: 0.8;
    transform: scale3d(1, 1, 1);
  }

  to {
    opacity: 0;
    transform: scale3d(1.2, 1.2, 1);
  }
`

export const bounceAnimation = keyframes`
  0% {
    transform: scale(0.99);
  }

  100% {
    transform: scale(1);
  }
`

// for circles we can scale width and height by the same percentage
export const circlePulseAnimation = keyframes`
0% {
  transform: translate(-50%, -50%) scale(0.95);
  opacity: 0.5;
  border-width: 4px;
  border-radius: var(--pulse-border-radius)
}

100% {
  transform: translate(-50%, -50%) scale(1.2);
  opacity: 0;
  border-width: 1px;
  border-radius: calc(var(--pulse-border-radius) * 1.5);
}
`

// for vertical we need to scale width and height by different percentages
// so the pulse width appears more uniform
export const verticalPulseAnimation = keyframes`
0% {
  transform: translate(-50%, -50%) scale(0.95);
  opacity: 0.5;
  border-width: 4px;
  border-radius: var(--pulse-border-radius)
}

100% {
  transform: translate(-50%, -50%) scale(1.2, 1.15);
  opacity: 0;
  border-width: 1px;
  border-radius: calc(var(--pulse-border-radius) * 1.5);
}
`
